module.exports = __webpack_public_path__ + "media/images/bubble-img-service-intro-answer-body-e42e0e27ceee86fcfe2433d08b065e40.png";